import { SearchQuery } from "shared/data/reducers/types/storage";
import {
  getFirstPenaltyStartDate,
  isPenaltyActive,
} from "shared/lib/hotels/cancellationPolicy";
import { RoomCategory } from "shared/types/hotels";

const filterRefundableOnly = (searchQuery: SearchQuery) => (
  room: RoomCategory
): boolean => {
  const { refundableOnly } = searchQuery;

  if (!refundableOnly) {
    return true;
  }

  const fromDateStr = getFirstPenaltyStartDate(
    room.PaymentConditions?.CancellationCharge
  );

  if (!fromDateStr) {
    return false;
  }

  // Non-refundable if first penalty starts today or earlier.
  const isNonRefundable = isPenaltyActive(fromDateStr);

  return !isNonRefundable;
};

export default filterRefundableOnly;
